import axios from 'axios';

export default {

  createUser(firstName, lastName, nickName, email, password) {
    const user = {
      firstName: firstName,
      lastName: lastName,
      nickname: nickName,
      email: email,
      password: password,
    }
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}users`, user)
  },

  getUserInfo() {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}user-info`)
  },

  saveSettings(settings) {
    return axios.patch(`${process.env.VUE_APP_RAISON_API_URL}user-info`, settings)
  },

  setMode(store, mode) {
    // console.log('setMode', mode);
    store
      .dispatch('setMode', mode)
      .catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err.messages] });
      });
  },


};